// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"496":"campaigns","528":"reports","594":"about","854":"widgets"}[chunkId] || chunkId) + "." + {"496":"b6e84e9f","512":"b6aff2e6","528":"81779f53","594":"e47fb60f","854":"7b288296"}[chunkId] + ".js";
};